import React from 'react';

import Divider from '@material-ui/core/Divider';

import { isDefined, toReadableCoordinate } from '../../../../utils/helpers';
import COLORS from '../../../../constants/colors';
import GoogleAutoComplete from '../../../maps/GoogleAutoComplete';
import IProduct from '../../../../models/product';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';

interface IAddressProps {
  isCreatingNew?: boolean;
  state: IProduct;
  setState: (state: IProduct) => void;
  approve?: boolean;
  product?: IProduct;
  readOnly?: boolean;
}

interface ILatLng {
  lat?: number;
  lng?: number;
}

export const Address = ({ approve, isCreatingNew, state, setState, product, readOnly }: IAddressProps) => {
  const [addressError, setAddressError] = React.useState(false);

  const onSelectAddress = (locationInfo: string, latLng: ILatLng) => {
    setState({
      ...state,
      location: locationInfo,
      latitude: latLng.lat || state.latitude,
      longitude: latLng.lng || state.longitude,
    });
  };

  const onErrorLoadingAddressComponent = () => {
    setAddressError(true);
  };
  return (
    <>
      {!isCreatingNew && (
        <>
          <Divider style={{ marginTop: 20 }} />
          <h4 style={{ marginBottom: 2 }}>
            Current address is set to:{' '}
            <span style={{ fontWeight: 'normal' }}>
              {product?.location} (lat: {toReadableCoordinate(product?.latitude)}, lng:{' '}
              {toReadableCoordinate(product?.longitude)})
            </span>
          </h4>
          {state.location !== product?.location && (
            <h4
              style={{
                color: COLORS.mainGreen,
                marginTop: 2,
              }}
            >
              New address will be:{' '}
              <span
                style={{
                  fontWeight: 'normal',
                  color: 'black',
                }}
              >
                {state.location} (lat: {toReadableCoordinate(state?.latitude)}, lng:{' '}
                {toReadableCoordinate(state?.longitude)})
              </span>
            </h4>
          )}
        </>
      )}
      <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
        <div style={{ flexGrow: 1 }}>
          <GoogleAutoComplete
            readOnly={readOnly}
            // containerStyle={{
            //   marginBottom: 40,
            // }}
            onSelectAddress={onSelectAddress}
            currentAddress={isDefined(state.location) ? state.location : ''}
            showLatLngInfo={isCreatingNew}
            latitude={state.latitude}
            longitude={state.longitude}
            onFailureLoadingComponent={onErrorLoadingAddressComponent}
            label={readOnly ? '' : undefined}
            withLabel
            labelOptions={{
              heading: 'Adress till producent',
              text: 'Denna information används för att matcha producenter med försäljningsomårde.',
            }}
          />
        </div>
        {approve && state?.approve?.find(x => x.field === 'location') && (
          <ThreeWaySwitch
            readOnly={readOnly}
            state={state}
            setState={setState}
            name="location"
            style={{ marginTop: 48 }}
          />
        )}
      </div>

      {addressError && (
        <p>
          Could not load address selection. You can still upload product. Current address on product will still be used.
          Contact Sygrid to correct this later.
        </p>
      )}
    </>
  );
};

export default Address;
